import { Phone, ArrowRight, CheckCircle2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { SEO } from '../components/SEO';
import { companyInfo } from '../data/pricing';

export const KitchenElectrician = () => {
  return (
    <div className="min-h-screen bg-[#F8F9FA]">
      <SEO 
        title="Kitchen Electrician London | Kitchen Electrical Installation | Crescent Electrical"
        description="Professional kitchen electrical installation across London. Work with your kitchen fitter for perfect electrical coordination. Ovens, hobs, lighting, sockets. Get your quote."
        canonical="https://crescentelectrical.co.uk/kitchen-electrician"
      />

      {/* Hero */}
      <section className="bg-gradient-to-br from-[#0B132B] to-[#1C2541] text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight mb-6">
            KITCHEN ELECTRICAL
            <span className="block text-[#0066FF] mt-2">INSTALLATIONS</span>
          </h1>
          <p className="text-xl text-gray-300 mb-8 max-w-3xl">
            Professional electrical installation for kitchen renovations. We coordinate with your kitchen installer to ensure perfect timing and placement.
          </p>
          <Button 
            size="lg"
            onClick={() => window.location.href = '/rewire-quote'}
            className="bg-[#0066FF] hover:bg-[#0052CC] text-white"
          >
            Get Kitchen Electrical Quote
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </div>
      </section>

      {/* Services */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
          <h2 className="text-4xl font-bold text-[#0F172A] text-center mb-12">
            Kitchen Electrical Services
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              'Dedicated oven circuits',
              'Induction hob supplies',
              'Additional socket circuits',
              'Integrated appliance supplies',
              'Under-cabinet LED lighting',
              'Pendant and feature lighting',
              'Downlights and spotlights',
              'Extractor fan supplies',
              'Kitchen island power',
              'USB charging sockets',
              'Smart lighting controls',
              'Consumer unit alterations',
              'Testing and certification',
              'Building Control notification'
            ].map((service, idx) => (
              <div key={idx} className="flex items-start gap-3 bg-[#F8F9FA] p-4 rounded-lg">
                <CheckCircle2 className="h-6 w-6 text-[#0066FF] flex-shrink-0 mt-0.5" />
                <span className="text-[#475569] font-medium">{service}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How We Work */}
      <section className="py-20 bg-[#F8F9FA]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-[#0F172A] mb-6">
                RENOVATING YOUR KITCHEN?
              </h2>
              <p className="text-lg text-[#475569] mb-6">
                We work directly with your kitchen installer or builder to coordinate electrical installation at every stage. 
                From initial socket positioning through to final appliance testing.
              </p>
              <p className="text-lg text-[#475569] mb-8">
                Whether you're working with a kitchen company, independent fitter, or managing the project yourself, 
                we ensure your electrical installation is ready when you need it.
              </p>
              <Button 
                onClick={() => window.location.href = '/rewire-quote'}
                className="bg-[#0066FF] hover:bg-[#0052CC] text-white"
              >
                Request Your Quote
              </Button>
            </div>
            <div>
              <img 
                src="https://images.unsplash.com/photo-1682888813913-e13f18692019?w=800&q=85"
                alt="Modern kitchen electrical installation"
                className="rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gradient-to-br from-[#0B132B] to-[#1C2541] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12 text-center">
          <h2 className="text-4xl font-bold mb-6">Ready to Start Your Kitchen Project?</h2>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-6">
            <Button 
              size="lg"
              onClick={() => window.location.href = '/rewire-quote'}
              className="bg-[#0066FF] hover:bg-[#0052CC] text-white"
            >
              Get A Quote
            </Button>
          </div>
          <a 
            href={`tel:${companyInfo.phone}`}
            className="inline-flex items-center gap-2 text-[#0066FF] hover:text-[#F59E0B] font-semibold text-lg"
          >
            <Phone className="h-5 w-5" />
            {companyInfo.phone}
          </a>
        </div>
      </section>
    </div>
  );
};
